import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * GET
 * /api/geo/us/states
 * 
 * Returns all states for USA
 */
export const getUsaStates = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/geo/us/states`, config)
      .then((resp) => {
        console.log("getUsaStates", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/geo/states/{countryId: integer($int32)}
 * 
 * Returns all states by country
 */
export const getStatesByCountryId = (countryId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/geo/states/${countryId}`, config)
      .then((resp) => {
        console.log("getStatesByCountryId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      })
  });
};

/**
 * GET
 * /api/geo/distance/unit/types
 * 
 * Returns all distance unit types
 */
export const getDistanceUnitTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/geo/distance/unit/types`, config)
      .then((resp) => {
        console.log("getDistanceUnitTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/geo/country
 * 
 * Returns all country
 */
export const getCountries = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/geo/country`, config)
      .then((resp) => {
        console.log("getCountries", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/geo/coordinate/address/{address: string}
 * 
 * Returns lat/long for an address
 */
export const getLatLon = (address) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/geo/coordinate/address/${address}`, config)
      .then((resp) => {
        console.log("getLatLon", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
